const standardGimmickMatchesData = [
	{
		"name" : "2/3 Falls",
		"cost" : 90,
		"ratingBoost" : 1.25,
		"popularityIncrease" : 2.2,
		"popularityDecrease" : 0.5,
		"injuryRate" : 1.15,
		"description" : "The first superstar to score two falls wins.",
		"available" : true,
		"cashinContractName" : null,
		"monthsToExpire" : 12,
		"generateObject" : false,
		"generateLocation" : false,
		"matchContractName" : null,
		"consequence" : null,
		"special" : false,
		"rules" : "2/3_falls",
		"addRandomWeapons" : false,
		"graphicType" : null
	},
	{
		"name" : "Special Referee",
		"cost" : 60,
		"ratingBoost" : 1.13,
		"popularityIncrease" : 1.55,
		"popularityDecrease" : 0.8,
		"injuryRate" : 1.05,
		"description" : "A guest referee is selected to enforce the match.",
		"available" : true,
		"cashinContractName" : null,
		"monthsToExpire" : 12,
		"generateObject" : false,
		"generateLocation" : false,
		"matchContractName" : null,
		"consequence" : null,
		"special" : false,
		"rules" : "special_referee",
		"addRandomWeapons" : false,
		"graphicType" : null
	},
	{
		"name" : "Pole",
		"cost" : 20,
		"ratingBoost" : 1.0,
		"popularityIncrease" : 1.3,
		"popularityDecrease" : 0.9,
		"injuryRate" : 1.05,
		"description" : "An object hangs off a pole, the goal being to claim it or use it. Can be a hit or a big miss!",
		"available" : true,
		"cashinContractName" : null,
		"monthsToExpire" : 12,
		"generateObject" : true,
		"generateLocation" : false,
		"matchContractName" : null,
		"consequence" : null,
		"special" : false,
		"rules" : null,
		"addRandomWeapons" : false,
		"graphicType" : null
	},
	{
		"name" : "Elimination",
		"cost" : 30,
		"ratingBoost" : 1.15,
		"popularityIncrease" : 1.5,
		"popularityDecrease" : 0.7,
		"injuryRate" : 1.05,
		"description" : "Teams battle it out in an elimination tag match, where an entire team must be eliminated for the match to end.",
		"available" : true,
		"cashinContractName" : null,
		"monthsToExpire" : 12,
		"generateObject" : false,
		"generateLocation" : false,
		"matchContractName" : null,
		"consequence" : null,
		"special" : false,
		"rules" : "elimination",
		"addRandomWeapons" : false,
		"graphicType" : null
	},
	{
		"name" : "Open Challenge",
		"cost" : 60,
		"ratingBoost" : 1.1,
		"popularityIncrease" : 1.55,
		"popularityDecrease" : 0.8,
		"injuryRate" : 1.05,
		"description" : "A random superstar shows up to answer the open challenge!",
		"available" : true,
		"cashinContractName" : null,
		"monthsToExpire" : 12,
		"generateObject" : false,
		"generateLocation" : false,
		"matchContractName" : null,
		"consequence" : "random_opponent",
		"special" : false,
		"rules" : null,
		"addRandomWeapons" : false,
		"graphicType" : null
	},
	{
		"name" : "Hair vs Hair",
		"cost" : 110,
		"ratingBoost" : 1.18,
		"popularityIncrease" : 1.66,
		"popularityDecrease" : 0.6,
		"injuryRate" : 1.06,
		"description" : "The losing superstar gets their hair shaved off!",
		"available" : true,
		"cashinContractName" : null,
		"monthsToExpire" : 12,
		"generateObject" : false,
		"generateLocation" : false,
		"matchContractName" : null,
		"consequence" : "remove_hair",
		"special" : false,
		"rules" : null,
		"addRandomWeapons" : false,
		"graphicType" : null
	},
	{
		"name" : "Submission",
		"cost" : 25,
		"ratingBoost" : 1.08,
		"popularityIncrease" : 1.45,
		"popularityDecrease" : 0.85,
		"injuryRate" : 1.05,
		"description" : "The first superstar to score a submission and make their opponent tap wins the match.",
		"available" : true,
		"cashinContractName" : null,
		"monthsToExpire" : 12,
		"generateObject" : false,
		"generateLocation" : false,
		"matchContractName" : null,
		"consequence" : null,
		"special" : false,
		"rules" : null,
		"addRandomWeapons" : false,
		"graphicType" : null
	},
	{
		"name" : "Ironman",
		"cost" : 60,
		"ratingBoost" : 1.2,
		"popularityIncrease" : 2.0,
		"popularityDecrease" : 0.6,
		"injuryRate" : 1.05,
		"description" : "A marathon match to see who is the best.",
		"available" : true,
		"cashinContractName" : null,
		"monthsToExpire" : 12,
		"generateObject" : false,
		"generateLocation" : false,
		"matchContractName" : null,
		"consequence" : null,
		"special" : false,
		"rules" : null,
		"addRandomWeapons" : false,
		"graphicType" : null
	},
	{
		"name" : "Mask vs Mask",
		"cost" : 130,
		"ratingBoost" : 1.18,
		"popularityIncrease" : 1.66,
		"popularityDecrease" : 0.6,
		"injuryRate" : 1.06,
		"description" : "The losing superstar is forced to unmask!",
		"available" : true,
		"cashinContractName" : null,
		"monthsToExpire" : 12,
		"generateObject" : false,
		"generateLocation" : false,
		"matchContractName" : null,
		"consequence" : "remove_mask",
		"special" : false,
		"rules" : null,
		"addRandomWeapons" : false,
		"graphicType" : null
	},
	{
		"name" : "Mask vs Hair",
		"cost" : 130,
		"ratingBoost" : 1.18,
		"popularityIncrease" : 1.66,
		"popularityDecrease" : 0.6,
		"injuryRate" : 1.06,
		"description" : "One superstar will be forced to either remove their mask or shave their hair!",
		"available" : true,
		"cashinContractName" : null,
		"monthsToExpire" : 12,
		"generateObject" : false,
		"generateLocation" : false,
		"matchContractName" : null,
		"consequence" : "remove_mask_or_hair",
		"special" : false,
		"rules" : null,
		"addRandomWeapons" : false,
		"graphicType" : null
	},
	{
		"name" : "Battle Royal",
		"cost" : 60,
		"ratingBoost" : 1.13,
		"popularityIncrease" : 1.2,
		"popularityDecrease" : 0.4,
		"injuryRate" : 1.05,
		"description" : "Superstars are eliminated if thrown over the top rope and both feet touch the floor. Last remaining superstar wins!",
		"available" : true,
		"cashinContractName" : null,
		"monthsToExpire" : 12,
		"generateObject" : false,
		"generateLocation" : false,
		"matchContractName" : null,
		"consequence" : null,
		"special" : false,
		"rules" : "battle_royal",
		"addRandomWeapons" : false,
		"graphicType" : null
	},
	{
		"name" : "Brawl",
		"cost" : 25,
		"ratingBoost" : 1.1,
		"popularityIncrease" : 1.55,
		"popularityDecrease" : 0.8,
		"injuryRate" : 1.1,
		"description" : "Superstars brawl it out in a special location.",
		"available" : false,
		"cashinContractName" : null,
		"monthsToExpire" : 12,
		"generateObject" : false,
		"generateLocation" : true,
		"matchContractName" : null,
		"consequence" : null,
		"special" : false,
		"rules" : null,
		"addRandomWeapons" : true,
		"graphicType" : null
	},
	{
		"name" : "Ladder",
		"cost" : 35,
		"ratingBoost" : 1.13,
		"popularityIncrease" : 1.6,
		"popularityDecrease" : 0.8,
		"injuryRate" : 1.15,
		"description" : "The only way to win is to climb the ladder and grab the prize.",
		"available" : true,
		"cashinContractName" : null,
		"monthsToExpire" : 12,
		"generateObject" : false,
		"generateLocation" : false,
		"matchContractName" : null,
		"consequence" : null,
		"special" : false,
		"rules" : null,
		"addRandomWeapons" : false,
		"graphicType" : "ladder"
	},
	{
		"name" : "I Quit",
		"cost" : 50,
		"ratingBoost" : 1.16,
		"popularityIncrease" : 1.7,
		"popularityDecrease" : 0.75,
		"injuryRate" : 1.12,
		"description" : "The only way to win is to humiliate your opponent and make them quit.",
		"available" : true,
		"cashinContractName" : null,
		"monthsToExpire" : 12,
		"generateObject" : false,
		"generateLocation" : false,
		"matchContractName" : null,
		"consequence" : null,
		"special" : false,
		"rules" : null,
		"addRandomWeapons" : false,
		"graphicType" : null
	},
	{
		"name" : "First Blood",
		"cost" : 45,
		"ratingBoost" : 1.13,
		"popularityIncrease" : 1.45,
		"popularityDecrease" : 0.85,
		"injuryRate" : 1.05,
		"description" : "The first superstar to make their opponent bleed wins the match.",
		"available" : true,
		"cashinContractName" : null,
		"monthsToExpire" : 12,
		"generateObject" : false,
		"generateLocation" : false,
		"matchContractName" : null,
		"consequence" : null,
		"special" : false,
		"rules" : null,
		"addRandomWeapons" : false,
		"graphicType" : null
	},
	{
		"name" : "Loser Leaves",
		"cost" : 75,
		"ratingBoost" : 1.2,
		"popularityIncrease" : 2.0,
		"popularityDecrease" : 0.6,
		"injuryRate" : 1.05,
		"description" : "A grudge match in which the loser is forced to take takes a hiatus from the company.",
		"available" : false,
		"cashinContractName" : null,
		"monthsToExpire" : 12,
		"generateObject" : false,
		"generateLocation" : false,
		"matchContractName" : null,
		"consequence" : "loser_unavailable",
		"special" : false,
		"rules" : null,
		"addRandomWeapons" : false,
		"graphicType" : null
	},
	{
		"name" : "Casket",
		"cost" : 45,
		"ratingBoost" : 1.13,
		"popularityIncrease" : 1.45,
		"popularityDecrease" : 0.85,
		"injuryRate" : 1.05,
		"description" : "The only way to win is to put your opponent in a casket and close it!",
		"available" : false,
		"cashinContractName" : null,
		"monthsToExpire" : 12,
		"generateObject" : false,
		"generateLocation" : false,
		"matchContractName" : null,
		"consequence" : null,
		"special" : false,
		"rules" : null,
		"addRandomWeapons" : false,
		"graphicType" : "casket"
	},
	{
		"name" : "Steel Cage",
		"cost" : 40,
		"ratingBoost" : 1.13,
		"popularityIncrease" : 1.6,
		"popularityDecrease" : 0.8,
		"injuryRate" : 1.15,
		"description" : "Superstars are locked inside a steel cage, with only one survivor.",
		"available" : true,
		"cashinContractName" : null,
		"monthsToExpire" : 12,
		"generateObject" : false,
		"generateLocation" : false,
		"matchContractName" : null,
		"consequence" : null,
		"special" : false,
		"rules" : null,
		"addRandomWeapons" : false,
		"graphicType" : "cage_grey"
	},
	{
		"name" : "Street Fight",
		"cost" : 10,
		"ratingBoost" : 1.05,
		"popularityIncrease" : 1.3,
		"popularityDecrease" : 0.9,
		"injuryRate" : 1.05,
		"description" : "Superstars battle it out anywhere in the arena using weapons.",
		"available" : true,
		"cashinContractName" : null,
		"monthsToExpire" : 12,
		"generateObject" : false,
		"generateLocation" : false,
		"matchContractName" : null,
		"consequence" : null,
		"special" : false,
		"rules" : null,
		"addRandomWeapons" : true,
		"graphicType" : null
	},
	{
		"name" : "Tables",
		"cost" : 20,
		"ratingBoost" : 1.1,
		"popularityIncrease" : 1.3,
		"popularityDecrease" : 0.9,
		"injuryRate" : 1.1,
		"description" : "The only way to win is to put your opponent through a table.",
		"available" : false,
		"cashinContractName" : null,
		"monthsToExpire" : 12,
		"generateObject" : false,
		"generateLocation" : false,
		"matchContractName" : null,
		"consequence" : null,
		"special" : false,
		"rules" : null,
		"addRandomWeapons" : false,
		"graphicType" : "table"
	},
	{
		"name" : "Unsanctioned",
		"cost" : 35,
		"ratingBoost" : 1.13,
		"popularityIncrease" : 1.6,
		"popularityDecrease" : 0.8,
		"injuryRate" : 1.1,
		"description" : "A fight without any rules or consequences where anything goes.",
		"available" : false,
		"cashinContractName" : null,
		"monthsToExpire" : 12,
		"generateObject" : false,
		"generateLocation" : false,
		"matchContractName" : null,
		"consequence" : null,
		"special" : false,
		"rules" : null,
		"addRandomWeapons" : true,
		"graphicType" : null
	},
	{
		"name" : "Steel Cell",
		"cost" : 80,
		"ratingBoost" : 1.25,
		"popularityIncrease" : 2.2,
		"popularityDecrease" : 0.5,
		"injuryRate" : 1.15,
		"description" : "Superstars are locked in a large, high steel cell, where they battle to survive.",
		"available" : false,
		"cashinContractName" : null,
		"monthsToExpire" : 12,
		"generateObject" : false,
		"generateLocation" : false,
		"matchContractName" : null,
		"consequence" : null,
		"special" : false,
		"rules" : null,
		"addRandomWeapons" : false,
		"graphicType" : "cage_grey"
	},
	{
		"name" : "TLC",
		"cost" : 65,
		"ratingBoost" : 1.2,
		"popularityIncrease" : 1.8,
		"popularityDecrease" : 0.7,
		"injuryRate" : 1.175,
		"description" : "Tables Ladders and Chairs, oh my!",
		"available" : false,
		"cashinContractName" : null,
		"monthsToExpire" : 12,
		"generateObject" : false,
		"generateLocation" : false,
		"matchContractName" : null,
		"consequence" : null,
		"special" : false,
		"rules" : null,
		"addRandomWeapons" : false,
		"graphicType" : "tables_ladders_chairs"
	},
	{
		"name" : "LMS",
		"cost" : 50,
		"ratingBoost" : 1.16,
		"popularityIncrease" : 1.7,
		"popularityDecrease" : 0.75,
		"injuryRate" : 1.1,
		"description" : "The only way to win is to knock your opponent out for a ten count.",
		"available" : false,
		"cashinContractName" : null,
		"monthsToExpire" : 12,
		"generateObject" : false,
		"generateLocation" : false,
		"matchContractName" : null,
		"consequence" : null,
		"special" : false,
		"rules" : null,
		"addRandomWeapons" : true,
		"graphicType" : null
	}
];

export {standardGimmickMatchesData}
